import { getPillarArticles } from '@/data/pillarArticles';

const HOME_IMAGE =
  'https://readdy.ai/api/search-image?query=Colorful%20streetwear%20clothing%20rack%20with%20sneakers%20and%20caps%20in%20a%20bright%20minimal%20boutique%20store%2C%20vivid%20warm%20colors%2C%20soft%20natural%20light%2C%20editorial%20retail%20photography&width=1600&height=900&seq=hero-bg-02&orientation=landscape&nocache=true';

export interface SeoData {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  image?: string;
  type: 'website' | 'article';
  jsonLd: 'website' | 'article' | null;
}

function home(): SeoData {
  return {
    title: 'CSSBuy Spreadsheet 2026: Guides, Deals, QC & Shipping',
    description:
      'Find the CSSBuy Spreadsheet, buying guides, information about QC, warehouse, shipping, coupons and reviews. Compare options and find updated resources for your purchases.',
    keywords:
      'CSSBuy Spreadsheet, CSSBuy Review, CSSBuy Shipping, CSSBuy Coupon, CSSBuy Discount Code, CSSBuy Warehouse, CSSBuy Legit, CSSBuy QC',
    canonicalPath: '/',
    image: HOME_IMAGE,
    type: 'website',
    jsonLd: 'website',
  };
}

function articleGuide(): SeoData {
  return {
    title: 'CSSBuy Shopping Guide 2026: Complete Buying Guide',
    description:
      'A complete CSSBuy shopping guide covering how it works, finding products, quality control, warehouse, shipping, and safety tips for new buyers.',
    keywords:
      'CSSBuy Guide, CSSBuy Shopping Guide, CSSBuy Spreadsheet Guide, CSSBuy QC, CSSBuy Shipping',
    canonicalPath: '/article',
    image: HOME_IMAGE,
    type: 'article',
    jsonLd: 'article',
  };
}

export function resolveSeo(pathname: string): SeoData | null {
  if (pathname === '/' || pathname === '') return home();
  if (pathname === '/article') return articleGuide();

  if (pathname.startsWith('/article/')) {
    const slug = pathname.slice('/article/'.length).split('?')[0];
    const article = getPillarArticles('en').find((a) => a.slug === slug);
    if (!article) return null;
    const shortTopic = article.title.split(':')[0].trim();
    return {
      title: article.title,
      description: article.excerpt,
      keywords: `CSSBuy ${shortTopic}, CSSBuy Spreadsheet, CSSBuy Guide`,
      canonicalPath: `/article/${article.slug}`,
      image: article.image,
      type: 'article',
      jsonLd: 'article',
    };
  }

  return null;
}